<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q4F3hf/tc-custom/9780374713201.jpg?1736426291168" alt="This image is the cover for the book Why Grow Up?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Grow Up?
      </h1>
      <p class="bookDescription body article font2">
        <b>“Accessible philosophy doesn’t get much better than this insightful review of what Enlightenment thinkers such as Kant and Rousseau have to offer people today.” —<i>Publishers Weekly </i>(starred review)</b><br/><br/>In <i>Why Grow Up?</i> the philosopher Susan Neiman asks not just why one should grow up but how. In making her case she draws chiefly from the thought of Kant and Rousseau, who articulated very different theories on the proper way to “come of age.” But these thinkers complement each other in seeking a “path between mindlessly accepting everything you’re told and mindlessly rejecting it,” and in learning to live without despair in a world marked by painful realities and uncertainties.<br/><br/>Neiman challenges both those who dogmatically privilege innocence and those who see youth as weakness. Her chief opponents are those who equate maturity with cynicism. “In our day it is more common to meet people who are stuck in the mire of adolescence. The world turns out not to reflect the idea and ideals they had for it? So much the worse for ideals.”<br/><br/>To move beyond these immature positions, Neiman writes, is not simply to lapse into quiet resignation but to learn to take joy and satisfaction in what can be done and known, and to face rather than feel defeated by our inevitable limits.<br/><br/><b>“[Neiman] comes across as a patient pedagogue rather than an angry scold . . . <i>Why Grow Up?</i> isn’t an exercise in pop-culture polemics or pop-sociological cherry-picking. It’s a case for philosophy of an admirably old-fashioned kind.” —The New York Times Book Review</b><br/><br/><b>“A spirited defence of the aspiration to maturity.” —<i>The Guardian</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Neiman
      </h2>
      
      <p class="authorDescription body article"><P><B>Susan Neiman</B> is a moral philosopher and essayist. She is the author of several books, including <I>Moral Clarity: A Guide for Grown-Up Idealists </I>and <I>Evil in Modern Thought: An Alternative History of Philosophy</I>. She is currently the director of the Einstein Forum in Potsdam.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16c8b7b5